<template>
    <!-- The Modal -->
  <div class="modal fade mt-8" id="infromationModal">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body" v-if="information == 'mobile'">
            <div class="font-md font-weight-bold text-black pl-2">Where can I find my<br />Lazada mobile number?</div>
            <ol class="pl-4 mb-0 mt-4 text-secondary font-sm" type="1">
                <li>Open Lazada app</li>
                <li>Click the Account tab located at the bottom right corner </li>
                <li>Go to Settings </li>
                <li>Click on your Account Information</li>
            </ol>
        </div>
        <div class="modal-body" v-else-if="information == 'email'">
            <div class="font-md font-weight-bold text-black pl-2">Where can I find my<br />Lazada email address?</div>
            <ol class="pl-4 mb-0 mt-4 text-secondary font-sm" type="1">
                <li>Open Lazada app</li>
                <li>Click the Account tab located at the bottom right corner </li>
                <li>Go to Settings </li>
                <li>Click on your Account Information</li>
            </ol>
        </div>
        <div class="modal-footer border-0">
            <button type="button" class="btn btn-link text-success" data-bs-dismiss="modal">OK</button>
        </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
    props: {
        information: String
    },
    methods: {
        data() {
            return {
                
            }
        },
    },
}
</script>
<style scoped>
.modal-padding {
    padding: 24px;
}
.close-icon {
    color: #E11931;
    font-size: 18px;
}
a {
    color: #000;
    
}
.collapse-header {
    overflow: hidden;
}
.card-title-collapse {
    background: #fff;
    padding: 12px 0 12px 12px;
    font-size: 16px;
    font-weight: bold;
    float: left;
    width: 90%;
}
.card-arrow-collapse {
    float: right;
    width: 10%;
    text-align: right;
    padding: 10px 12px 12px 12px;
}
.card-link[data-toggle="collapse"] b.arrow:before {
    content: "\f106";    /* angle-down */
    font-family: 'Font Awesome 5 Free';
}
.card-link[data-toggle="collapse"].collapsed b.arrow:before {
    content: "\f107";    /* angle-up */
    font-family: 'Font Awesome 5 Free';
}
.faq-link-content {
    color: #49B672;
    font-weight: bold;
}
</style>